import { Navigate } from "react-router-dom";

// Account settings now live inside the consolidated Settings hub — kept as a redirect so any
// existing link/bookmark to /account still lands in the right place.
export default function AccountPage() {
  return <Navigate to="/settings?tab=account" replace />;
}
